<script>
    // external json file with refcode entries
    import * as rawData from './refcodes.json';

    export default {

        data () {
            return { data: null, };
        },

        /**
         * Set raw data to the datamember and translate entries
         * The created hook is called multiple times by vue.
         * Once for every usage of this mixin in views/components
         */
        created() {
            // bind parsed json entries to data member
            this.data = rawData.default;
            // translate entries once
            if (!this.data.TRANSLATED) {
                // loop over all data entries
                for (const [, value] of Object.entries(this.data.ENTRIES)) {
                    // value contains array of items
                    for (const item of value) {
                        // skip translation of operators: <, <=, >, etc.
                        if (item.description.length > 2) {
                            // replace description by translated value
                            item.description = this.$t(item.description);
                        }
                    }
                }
                // set translated to true
                this.data.TRANSLATED = true;
            }
        },

        methods: {

            /**
             * Lookup refcode entries by name
             * @param  {name} name [data entrie to look for]
             * @return {array}     [array of refcode entries]
             */
            $_getRefcodesByName(name) {
                for (const [key, value] of Object.entries(this.data.ENTRIES)) {
                    if (key === name) {
                        return value;
                    }
                }
                return null;
            },

        },

    };

</script>
